<div data-testid="purchase-return-order-page" class="p-6 flex-table-page">
  <!-- Header -->
  <div class="page-header flex-table-header">
    <h2 class="page-title">
      {{ "purchase_return_order.management.title" | translate }}
    </h2>
  </div>
  <!-- Search Form -->
  <app-search-form
    data-testid="purchase-return-order-search-form"
    [searchFormat]="searchFormConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'purchase-return-order-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        (primaryButtonClick)="onAdd()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="purchase-return-order-table"
      #advancedTable
      [dataSource]="dataSource()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [hasCheckColumn]="false"
      [hasSerialColumn]="false"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      [sortField]="sortField()"
      [sortOrder]="sortOrder()"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)"
    >
    <!-- Custom Template for Currency and Date Columns -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (column?.prop === "returnQty") {
        <span [class]="column?.styleClass">
          {{ value | number: "1.0-0" }}
        </span>
      }
      @if (column?.prop === "returnAmount") {
        <span [class]="(column?.styleClass || '') + ' currency-amount'">
          {{ formatCurrency(value) }}
        </span>
      }
      @if (column?.prop === "creationDate") {
        <span class="text-xs text-gray-600">
          {{ formatDate(value) }}
        </span>
      }
      @if (column?.prop === "status") {
        <div class="flex items-center justify-center gap-1 w-full">
          <p-tag
            data-testid="purchase-return-order-status-tag"
            [value]="getStatusLabel(value)"
            [severity]="getStatusSeverity(value)"
            styleClass="status-tag"
            [ngStyle]="getStatusStyle(value)"
            [pTooltip]="getStatusLabel(value)"
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            [showDelay]="300"
            [hideDelay]="0"
          />
        </div>
      }
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="inline-flex items-center gap-2 whitespace-nowrap">
        <!-- View button -->
        @if (canRead()) {
          <span
            [attr.data-testid]="'purchase-return-order-action-view-' + rowData.id"
            (click)="onView(rowData)"
            class="action-link action-view cursor-pointer"
          >
            {{ "common.actions.view" | translate }}
          </span>
        }

        <!-- Others button - only visible if there are actions available and user has permissions -->
        @if (
          getPORActions(rowData).length > 0 && hasEnabledPORActions(rowData)
        ) {
          <button
            [attr.data-testid]="'purchase-return-order-action-others-' + rowData.id"
            type="button"
            class="action-link action-others cursor-pointer"
            aria-haspopup="menu"
            (click)="toggleMenu($event, rowData)"
          >
            {{ "common.actions.others" | translate }}
          </button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Single Menu for All Actions -->
<p-menu
  data-testid="purchase-return-order-actions-menu"
  #actionMenu
  [popup]="true"
  [model]="currentMenuModel()"
  appendTo="body"
  [baseZIndex]="2100"
  styleClass="actions-menu text-[0.75rem]"
  [autoZIndex]="true"
></p-menu>

<!-- Toast Messages -->
<p-toast data-testid="purchase-return-order-toast"></p-toast>

<!-- Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'purchase-return-order-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
